import Input from "./input";
import { FormInputProps } from "./types";

const ConfigInput = (props: FormInputProps) => {
    const { config } = props;

    return (<Input
        cssName={config.cssName}
        name={config.name}
        label={config.label}
        fieldOptions={config.fieldOptions} />);
}

export default ConfigInput;